<aca-alert-message></aca-alert-message>
<div [ngClass]="(!this.embedded)?'background':'embeddedBackground'" class="accela-theme">
    <router-outlet></router-outlet>
</div>
